import { RadioContainer, RadioInput, RadioLabel } from "./index.styled";

interface RadioImgInputProps {
  id: string;
  radioGroup: string;
  checked: boolean;
  setChecked?: (value: boolean) => void;
  label: string;
  color?: string;
  value: any;
  img: string;
}

const RadioImgInputComponent: React.FC<RadioImgInputProps> = ({
  id,
  radioGroup,
  checked,
  setChecked,
  label,
  color = "black",
  value,
  img,
}) => {
  return (
    <RadioContainer htmlFor={id} selected={checked}>
      <RadioInput
        type="radio"
        id={id}
        name={radioGroup}
        color={color}
        checked={checked}
        value={value}
        onChange={() => setChecked && setChecked(!checked)}
        img={img}
      />
      <RadioLabel>{label}</RadioLabel>
    </RadioContainer>
  );
};

export default RadioImgInputComponent;
